<router-outlet></router-outlet>

<!-- Sidebar modals are below -->

<app-customer-invoices *ngIf="customerOverviewService.listOfModals.viewInvoicesModalOpened"
                       [customer]="customer">
</app-customer-invoices>

<app-customer-data [customer]="customer"
                   *ngIf="customerOverviewService.listOfModals.editCustomerModalOpened">
</app-customer-data>

<app-communication-data [selectedClub]="selectedClub"
                        *ngIf="customerOverviewService.listOfModals.editCommunicationModalOpened">
</app-communication-data>

<app-attributes [customer]="customer"
                *ngIf="customerOverviewService.listOfModals.editAttributeModalOpened">
</app-attributes>

<app-address *ngIf="customerOverviewService.listOfModals.createAddressesModalOpened"
             [customer]="customer">
</app-address>

<app-address-edit *ngIf="customerOverviewService.listOfModals.editAddressesModalOpened"
                  [customer]="customer">
</app-address-edit>

<app-bank-data *ngIf="customerOverviewService.listOfModals.createBankingDataModalOpened"
               [customer]="customer">
</app-bank-data>

<app-bank-data-edit *ngIf="customerOverviewService.listOfModals.editBankingDataModalOpened"
                    [customer]="customer">
</app-bank-data-edit>

<app-crm-membership *ngIf="customerOverviewService.listOfModals.createCrmMembershipModalOpened"
                    [customer]="customer">
</app-crm-membership>

<app-crm-membership-edit *ngIf="customerOverviewService.listOfModals.editCrmMembershipModalOpened"
                         [customer]="customer">
</app-crm-membership-edit>

<app-campai-membership-edit *ngIf="customerOverviewService.listOfModals.editCampaiMembershipModalOpened"
                            [customer]="customer">
</app-campai-membership-edit>

<app-contact-management *ngIf="customerOverviewService.listOfModals.createContactModalOpened"
                        [customer]="customer">
</app-contact-management>

<app-contact-management-edit *ngIf="customerOverviewService.listOfModals.editContactModalOpened"
                             [customer]="customer">
</app-contact-management-edit>

<app-reminder *ngIf="customerOverviewService.listOfModals.createReminderModalOpened"
              [customer]="customer">
</app-reminder>

<app-reminder-edit *ngIf="customerOverviewService.listOfModals.updateReminderModalOpened"
                   [customer]="customer">
</app-reminder-edit>

<app-tixx-select-view *ngIf="customerOverviewService.listOfModals.viewSubmissionDetailsModalOpened"
                      [customer]="customer">
</app-tixx-select-view>

<app-tixx-connection [customer]="customer"></app-tixx-connection>


<div class="esf-overlay esf-js-closeModal" style="top: 0;" [ngClass]="{'-is-open': tixxConnectionService.isBankSelectModalOpened}" *ngIf="tixxConnectionService.isBankSelectModalOpened">
  <div class="esf-modal" [ngClass]="{'-is-open': tixxConnectionService.isBankSelectModalOpened}">
    <header class="esf-modal__header">
      <h3 i18n='Customer choose bank account for TIXX@@customerOverviewComponent.bankAccountModal.selectBankAccount'>Select Bank Account</h3>
    </header>
    <div class="esf-modal__inner">
      <p i18n='Customer choose bank account help text for TIXX@@customerOverviewComponent.bankAccountModal.selectBankAccountHelpText'>Please select the bank data to use for ticket purchasing in TIXX</p>
      <table class="esf-table">
        <thead class="esf-table__head">
          <tr class="esf-table__row">
            <th class="esf-table__cell esf-table__cell--head" data-label="Select"
                i18n-data-label='Table cell heading for selecting bank account@@general.tableCellLabel.bankAccountSelect'>
              <span class="esf-table__cell-inner"></span>
            </th>
            <th class="esf-table__cell esf-table__cell--head" data-label="IBAN"
                i18n-data-label='Table cell heading for bank account IBAN@@general.tableCellLabel.bankAccountIBAN'>
              <span class="esf-table__cell-inner">IBAN</span>
            </th>
            <th class="esf-table__cell esf-table__cell--head" data-label="BIC"
                i18n-data-label='Table cell heading for bank account BIC@@general.tableCellLabel.bankAccountBIC'>
              <span class="esf-table__cell-inner">BIC</span>
            </th>
            <th class="esf-table__cell esf-table__cell--head" data-label="Bank"
                i18n-data-label='Table cell heading for bank account bank name@@general.tableCellLabel.bankAccountBankName'>
              <span class="esf-table__cell-inner">Bank</span>
            </th>
            <th class="esf-table__cell esf-table__cell--head">
              <span class="esf-table__cell-inner"></span>
            </th>
          </tr>
        </thead>
        <tbody class="esf-table__body">
          <tr class="esf-table__row" *ngFor="let bankAccount of customer.bankAccounts; let i = index">
            <td class="esf-table__cell" data-label="Select"
                i18n-data-label='Table cell heading for selecting bank account@@general.tableCellLabel.selectBankAccount'>
              <span class="esf-table__cell-inner">
                <div class="esf-check-radio">
                  <input class="esf-check-radio__input esf-check-radio--radio__input"
                         [defaultChecked]="defaultChecked(i)"
                         [attr.id]="'BankAccount' + bankAccount.id"
                         [value]="bankAccount.id"
                         (change)="tixxConnectionService.setSelectedBankId(bankAccount.id)"
                         type="radio" name="bankAccountId" value="{{ bankAccount.id }}">
                  <label class="esf-check-radio__label esf-check-radio--radio__label" style="display: inline" [attr.for]="'BankAccount' + bankAccount.id"></label>
                </div>
              </span>
            </td>
            <td class="esf-table__cell" data-label="IBAN"
                i18n-data-label='Table cell heading for bank account IBAN@@general.tableCellLabel.bankAccountIBAN'>
              <span class="esf-table__cell-inner">{{ bankAccount.IBAN }}</span>
            </td>
            <td class="esf-table__cell" data-label="BIC"
                i18n-data-label='Table cell heading for bank account BIC@@general.tableCellLabel.bankAccountBIC'>
              <span class="esf-table__cell-inner">{{ bankAccount.BIC }}</span>
            </td>
            <td class="esf-table__cell" data-label="Bank"
                i18n-data-label='Table cell heading for bank account bank name@@general.tableCellLabel.bankAccountBankName'>
              <span class="esf-table__cell-inner">{{ bankAccount.bankName }}</span>
            </td>
            <td class="esf-table__cell">
              <span class="esf-table__cell-inner">
                <button *ngIf="bankAccount.sepaMandates.length"
                        style="margin: 0 .6em"
                        class="esf-button esf-button--simple">
                  <svg class="esf-icon" width="16" height="16">
                    <use xlink:href="#esf-icon-euro"></use>
                  </svg>
                </button>
              </span>
            </td>
          </tr>
        </tbody>
      </table>
    </div>
    <footer class="esf-modal__footer">
      <div class="esf-submit-row">
        <div class="esf-submit-row__item">
          <button class="esf-button esf-button--standard esf-button--filled" (click)="tixxConnectionService.openTixxWebshop()"
                  i18n="Select bank account and open tixx@@general.button.selectBankAccountAndContinue">Select & Continue</button>
        </div>
        <div class="esf-submit-row__item">
          <button class="esf-button esf-button--standard esf-button--outlined"
                  (click)="tixxConnectionService.toggleBankSelectModalOpened(false); createBankData();"
                  i18n="Create new bank account action button@@general.button.createNewBankAccount">Add new bank data</button>
        </div>
      </div>
    </footer>
    <div class="esf-modal__close" (click)="tixxConnectionService.toggleBankSelectModalOpened(false)">
      <svg class="esf-icon esf-icon--darker" width="24" height="24">
        <use xlink:href="#esf-icon-close"></use>
      </svg>
    </div>
  </div>
</div>
